<template>
    <vue-scroll :ops="$ops">
        <div v-loading="$parentInfo.dialog_InvoiceBill.loading" style="max-height:700px">
            <div v-for="invoiceBill in $parentInfo.dialog_InvoiceBill.invoiceBills">
                <img :src="invoiceBill" alt="" style="width:700px">
            </div>
            <div v-if="$parentInfo.dialog_InvoiceBill.invoiceBillsLength===0">
                无票据
            </div>
        </div>
    </vue-scroll>
</template>

<script>
    export default {
        name: "Dialog_InvoiceBill",
        data() {
            return {};
        },
        created() {
            this.$parentInfo = this.$root.$children[0].$refs['dashboard'].$refs[this.$route.path];
            this.handleBill();
        },
        methods: {
            handleBill() {
                this.$parentInfo.dialog_InvoiceBill.loading = true;
                this.$wApi.send(this.$parentInfo.path, 'invoiceBill', {
                    'invoice_id': this.$store.state.modal.data.invoice_id,
                });
            },
        }
    }


</script>

<style scoped>

</style>